<template>
  <div class="container">
    <donut-page-title title="People" />
    <shoutouts-leaderboard-table
      :config="state.pointsConfig.config"
      :program="state.shoutoutsProgram.program"
      :for-people-page="true"
      :headers="props.headers"
      class="m-tx4"
    />
  </div>
</template>

<script setup>
  import { useStore } from 'vuex';

  const { state } = useStore();

  const props = defineProps({
    headers: { type: Array, required: true },
  });
</script>
